export default __webpack_public_path__ + "static/media/5.e4d8a9be.svg";